<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>知识库</el-breadcrumb-item>
      <el-breadcrumb-item>知识库详情</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel mt-20" v-if="wiki.id">
      <div class="mobile-preview">
        <div class="title">{{ wiki.title }}</div>
        <!-- <div class="mt-10">
          状态：{{ wiki.status == 2 ? '已发布' : '草稿' }}
        </div> -->
        <div class="font-12 text-gray">
          更新于：{{ $time(wiki.updated_at).format('YYYY/MM/DD HH:mm') }}
        </div>
        <div class="mt-5">
          <el-tag
            type="info"
            size="mini"
            v-for="item in wiki.item_category_names"
            :key="item"
            >{{ item.replace(/,/g, '-') }}</el-tag
          >
        </div>
        <!-- <div>创建人：{{ wiki.user.name }}</div> -->

        <!-- <div>
          正文形式：{{ wiki.content_type == 1 ? '网页链接' : '自定义' }}
        </div> -->
        <div v-if="wiki.content_type == 1" class="content">
          正文链接：{{ wiki.content }}
        </div>
        <div v-else class="mt-20 content" v-html="wiki.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { wikiDetail } from '@/service/getData'

export default {
  data() {
    return {
      loading: false,
      wiki: {},
    }
  },
  created() {
    const id = this.$route.params.id
    this.getData(id)
  },
  methods: {
    async getData(id) {
      this.loading = true
      let res = await wikiDetail(id)
      if (res.code == 0) {
        this.wiki = res.data
        this.loading = false
      }
    },
  },
}
</script>


<style scoped>
.title {
  font-size: 18px;
  font-weight: bold;
}

.mobile-preview {
  width: 375px;
  height: 667px;
  margin: 0 auto;
  overflow-y: auto;
  border: 1px solid #ddd;
  padding: 15px;
}

.content {
  word-break: break-all;
}

/deep/.content p {
  margin-bottom: 0;
}

/deep/.content img {
  max-width: 100%;
}
</style>